import { isEmpty } from "lodash-es";
import * as locatorServices from "../../services/locator.service";
import * as shippingServices from "../../services/shipping.service";
import {
  RETRIEVE_SERVICE_AREA_BY_ZIP_FAIL,
  RETRIEVE_SERVICE_AREA_BY_ZIP_SUCCESS,
  SEARCH_BRANCHES_FAIL,
  SEARCH_BRANCHES_SUCCESS,
} from "./types";

export const getServiceAreaByZip =
  ({ zip, countryCode, accountId }) =>
  async (dispatch, getState) => {
    try {
      let userData = {},
        userState = getState().user;
      if (userState && userState.profile && !isEmpty(userState.profile)) {
        userData = {
          account_number: userState.profile.account_number,
          user_id: userState.profile.user_id,
        };
      }

      const dataParams = {
        zip_code: zip,
        country: countryCode,
        ...userData,
      };

      const response = await shippingServices.getServiceByZip(dataParams);
      if (response.status >= 200 && response.status < 300) {
        const { data } = response;
        dispatch({
          type: RETRIEVE_SERVICE_AREA_BY_ZIP_SUCCESS,
          zip,
          countryCode,
          serviceArea: data,
        });
      }
    } catch (error) {
      const errorData =
        (error.response && error.response.data) || error.message;
      dispatch({
        type: RETRIEVE_SERVICE_AREA_BY_ZIP_FAIL,
        zip,
        countryCode,
        serviceArea: {},
      });
      throw errorData;
    }
  };

export const searchBranches =
  ({ lat, lng, searchServiceArea, searchDropboxes, distance }) =>
  async (dispatch) => {
    try {
      const searchParams = {
        lat,
        lng,
        service_areas: searchServiceArea,
        drop_boxes: searchDropboxes,
        distance,
      };
      const response = await locatorServices.searchBranches(searchParams);
      if (response.status >= 200 && response.status < 300) {
        const { data } = response;
        if (!data.data && data.message === "No data") {
          throw Error("No branches found nearby.");
        }
        dispatch({
          type: SEARCH_BRANCHES_SUCCESS,
        });
        return data.data || [];
      }
    } catch (error) {
      const errorData =
        (error.response && error.response.data) || error.message;
      dispatch({
        type: SEARCH_BRANCHES_FAIL,
      });
      throw errorData;
    }
  };
